import React from 'react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'
import {Text, useStyleConfig} from '@chakra-ui/react'
import ItemCalloutMessages from '../item-variant/item-callout-msg'
import {BRAND_CODE_MARKETING_CLOUD} from '../../brand'
import {useBooleanCustomPreference} from '../../hooks/use-custom-preference'

const InformativeLabel = ({label, variant = '', width = 'auto', height = 'auto'}) => {
    const styles = useStyleConfig('InformativeLabel', {variant})
    return (
        // className added for MC/MCP
        <Text
            className={`${BRAND_CODE_MARKETING_CLOUD}-pdp__main-info__promo`}
            {...styles}
            width={width}
            height={height}
        >
            {label}
        </Text>
    )
}

InformativeLabel.propTypes = {
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    variant: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
}
export default InformativeLabel

export const InformativeLabelGroup = ({
    product,
    priceData,
    showPromotions = false,
    isBundle = false,
    isFreeGift = false,
}) => {
    const notShoppableCountry = useBooleanCustomPreference('notShoppableCountry')
    const intl = useIntl()
    const longTextLabels = []
    if (product?.c_badgeCommerce1) longTextLabels.push(product.c_badgeCommerce1)
    if (product?.c_badgeCommerce2) longTextLabels.push(product.c_badgeCommerce2)
    if (product?.c_badgeCommerce3) longTextLabels.push(product.c_badgeCommerce3)

    let onsalePromo
    if (priceData && priceData?.isOnSale) {
        const {listPrice, unitPrice} = priceData

        const unitPriceWithoutWeeefee =
            unitPrice -
            (product?.priceAdjustments?.length
                ? product.priceAdjustments
                      .filter((adj) => adj?.promotionId === 'weeeFee')
                      .reduce((sum, adj) => sum + (adj.price || 0), 0)
                : 0)

        onsalePromo = `-${intl.formatNumber((listPrice - unitPriceWithoutWeeefee) / listPrice, {
            style: 'percent',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        })}`
    }

    // we don't want to show the editorial labels if there is a coupon code
    const hideDefaultPromos = product?.priceAdjustments?.find((adj) => adj.couponCode)
    return (
        <>
            {showPromotions && <ItemCalloutMessages product={product} />}
            {!hideDefaultPromos &&
                !notShoppableCountry &&
                !isFreeGift &&
                (priceData?.isOnSale || priceData?.isOnSale === 'true') &&
                priceData.unitPrice !== 0 && (
                    <InformativeLabel
                        label={onsalePromo}
                        data-testid="product-omnibus-badge"
                        variant={isBundle ? 'light' : 'dark'}
                    />
                )}
            {!hideDefaultPromos && product?.c_isOfficina === 'true' && (
                <InformativeLabel
                    label={intl.formatMessage({
                        defaultMessage: 'Officina',
                        id: 'informative_label.officina',
                    })}
                    variant="light"
                    data-testid="product-officina-badge"
                />
            )}
            {!hideDefaultPromos && product?.c_marketingComunication === 'true' && (
                <InformativeLabel
                    label={intl.formatMessage({
                        defaultMessage: 'Online exclusive',
                        id: 'informative_label.online_exclusive',
                    })}
                    variant="light"
                    data-testid="product-omnibus-badge"
                />
            )}
            {!hideDefaultPromos && product?.c_inPromo === 'true' && (
                <InformativeLabel
                    label={intl.formatMessage({
                        defaultMessage: 'Promo',
                        id: 'informative_label.promo',
                    })}
                    variant="light"
                    data-testid="product-omnibus-badge"
                />
            )}
            {!hideDefaultPromos && product?.c_isBestSeller === 'true' && (
                <InformativeLabel
                    label={intl.formatMessage({
                        defaultMessage: 'Best seller',
                        id: 'informative_label.best_seller',
                    })}
                    variant="light"
                    data-testid="product-best-seller-badge"
                />
            )}
            {!hideDefaultPromos && product?.c_isNew === 'true' && (
                <InformativeLabel
                    label={intl.formatMessage({
                        defaultMessage: 'New',
                        id: 'informative_label.new',
                    })}
                    variant="light"
                    data-testid="product-omnibus-badge"
                />
            )}
            {!hideDefaultPromos &&
                longTextLabels.length > 0 &&
                longTextLabels.map((label, i) => {
                    return label && <InformativeLabel key={i} label={label} variant="light" />
                })}
        </>
    )
}

InformativeLabelGroup.propTypes = {
    product: PropTypes.object,
    priceData: PropTypes.object,
    showPromotions: PropTypes.bool,
    isBundle: PropTypes.bool,
    isFreeGift: PropTypes.bool,
}
